export default {
  nullData: 'No Data',
  look: 'View',
  operation: 'Operation',
  delete: 'Delete',
  cancel: 'Cancel',
  edit: 'Edit',
  sure: 'Sure',
  unknown: 'Unknown',
  query:'Query',
  other: 'Other',
  purchaser: 'Buyers',
  supplier: 'Suppliers',
  close: 'Close',
  type: 'Type',
  keyWord: 'Product',
  hsCode: 'HS Code',
  companyName: 'Company',
  countryorRegion: 'Country/Region',
  phone: 'Phone',
  email: 'Email',
  fax: 'Fax',
  media: 'Social Media',
  amount: 'Amount',
  download: 'Download',
  chinese: 'Chinese',
  english: 'English',
  export:'Download',
  tips: 'Tips',
  Unsubscribe: 'Unsubscribe',
  subscribedOver: 'Subscribed',
  subscribe: 'Subscribe',
  add: 'Add',
  addTo:'Add',
  enterprise: 'Enterprise',
  address: 'Address',
  more: 'More',
  translate: 'Translate',
  enter: 'Enter',
  submit:'Submit',
  brand:'Brand',
  autoTranslate:'Translate',
  back:'Back',
  save:'save',
  topeaseVip:'Hello Topease members：',
  topeasePro:'Topease Product Center',
  message: {
    weChatSucess: 'Wechat binding succeeded',
    notExist:'The page you are visiting does not exist',
    loading:'loading',
    jumping: 'Jump in, please wait',
    noPermission:'This account has no access to this country data.',
    noData:'No data',
    changeSucess: 'Language switching succeeded',
    ConsolidatedEnterprise:'The merged enterprise you are dissolving is your [followed] enterprise. When you dissolve and merge this enterprise, this enterprise will be removed from your list of followed enterprises.',
    prompt:{
      enterOpportunityList:'the opportunity list name',//this.$t('message.prompt.enterOpportunityList')
      cannotEmpty:'The input content cannot be empty',//this.$t('message.prompt.cannotEmpty')
      opportunityListName:'Opportunity list name',//this.$t('message.prompt.opportunityListName')
      pleaseEnter:'Please enter '//this.$t('message.prompt.pleaseEnter')
    },
    confirm:{
      wantLogout:'Do you want to log out?',//this.$t('message.confirm.wantLogout')
      cancelOpportunityList:'You are deleting the business opportunity list, and the subscription function of the business opportunity list will be automatically turned off. Are you sure you want to continue?',//this.$t('message.confirm.cancelOpportunityList')
      cancelFollow:'You are canceling your attention. The system will automatically close the subscription and exclusive access to this enterprise. Are you sure you want to continue?',//this.$t('message.confirm.cancelFollow')
      delectExport:'This operation will delete the exported enterprise record. Do you want to continue?',//this.$t('message.confirm.delectExport')
      delectTradeData:'This operation will delete the transaction data download record. Do you want to continue?',//this.$t('message.confirm.delectTradeData')
      actionWill:'This action will',//this.$t('message.confirm.actionWill')
      exclusiveEnterprise:'Exclusive access to the enterprise, continue?',//this.$t('message.confirm.exclusiveEnterprise')
      cancelEnterprise:'This operation will cancel paying attention to the selected enterprise. Do you want to continue?',//this.$t('message.confirm.cancelEnterprise')
      deleteContact:'You are deleting the contacts mined from "easy mail". The system will delete all contacts in the same batch of mining results. Please confirm your operation.',//this.$t('message.confirm.deleteContact')
      dataChange:'This operation will correct the data. Are you sure?',//this.$t('message.confirm.dataChange')
      importEmail:'This operation will select the enterprise to import easy search mail. Do you want to continue?',//this.$t('message.confirm.importEmail')
      deleteProduct:'This operation will delete the product analysis. Do you want to continue?',//this.$t('message.confirm.deleteProduct') 
      deleteHistory:'This operation will delete the historical search record. Do you want to continue?', //this.$t('message.confirm.deleteHistory')
      deleteThis:'This action will delete the',//this.$t('message.confirm.deleteThis')
      productTag:'Product data label',//this.$t('message.confirm.productTag')
      smartOpportunities: 'Smart business opportunities',//this.$t('message.confirm.smartOpportunities')
      isContinue:', continue?',//this.$t('message.confirm.isContinue')
    },
    warning:{
      fileDeleted: 'The file has been deleted',
      selectFile: 'Please select a file',//this.$t('message.warning.chooseOpportunityList')
      selectEnterprise: 'Please select an enterprise',//this.$t('message.warning.selectEnterprise')
      chooseFollowCompanyList: 'Please select an enterprise',//this.$t('message.warning.chooseFollowCompanyList')
      notEmpty:'Cannot be empty',//this.$t('message.warning.notEmpty')
      valueHo:'The filled value must be greater than 0',//this.$t('message.warning.valueHo')
      sectionValue:'Please fill in the required interval value.',//this.$t('message.warning.sectionValue')
      chooseSpecificC:'Please select a specific country to download.',//this.$t('message.warning.chooseSpecificC')
      noPermission:'This account has no permission.',//this.$t('message.warning.noPermission')
      masterEnterprise:'Please specify a master enterprise',//this.$t('message.warning.masterEnterprise')
      chooseTwoE:'Please select at least two enterprises',//this.$t('message.warning.chooseTwoE')
      chooseTradeData:'Please select trade data',//this.$t('message.warning.chooseTradeData')
      chooseHScode:'Enter at least two HS codes',//this.$t('message.warning.chooseHScode')
      tranISN:'Translation content cannot be empty',//this.$t('message.warning.tranISN')
      enterDes:'Please enter product description',//this.$t('message.warning.enterDes')
      currentKey:'Keywords currently included are“',//this.$t('message.warning.currentKey')
      condition:'”Conditions',//this.$t('message.warning.condition')
      enterHScode:'Please enter HS code',//this.$t('message.warning.enterHScode')
      enterProductName:'Please enter product keywords',//this.$t('message.warning.enterProductName')
      keyWordHave:'The keyword already exists',//this.$t('message.warning.keyWordHave')
      hsCodeHave:'The HS code already exists',//this.$t('message.warning.hsCodeHave')
      buyerName:'Please enter purchaser name',//this.$t('message.warning.buyerName')
      notifierName:'Please enter notifier name',//this.$t('message.warning.notifierName')
      currentHSCode:'Currently contains HS code as“',//this.$t('message.warning.currentHSCode')
      enterBrand:'Please enter brand',//this.$t('message.warning.enterBrand')
      brandExists:'The brand already exists',//this.$t('message.warning.brandExists')
      enterSuppName:'Please enter supplier name',//this.$t('message.warning.enterSuppName')
      enterOriginOut:'Please enter the country of origin (country of export)',//this.$t('message.warning.enterOriginOut')
      enterOriginImport:'Please enter the country of origin (importing country)',//this.$t('message.warning.enterOriginImport')
      originCountryHave:'The country of origin (exporting country) already exists',//this.$t('message.warning.originCountryHave')
      originCountryImportHave:'The country of origin (importing country) already exists',//this.$t('message.warning.originCountryImportHave')
      enterDeparture :'Please enter the port of departure / customs area',//this.$t('message.warning.enterDeparture')
      departureHave:'The port of departure / customs area already exists',//this.$t('message.warning.departureHave')
      enterObjective:'Please enter the port of destination / customs area',//this.$t('message.warning.enterObjective')
      objectiveHave:'The destination port / customs area already exists',//this.$t('message.warning.objectiveHave')
      contNotNull:'Translation content cannot be empty',//this.$t('message.warning.contNotNull')
      Pleasefill:'Please fill in the search information before searching',
      currentcountry:'Current country error, please switch countries again',
    },
    success:{
      deleteSuccess:'Deleted successfully', //this.$t('message.success.deleteSuccess')
      topSuccess:'Stick to top successfully', //this.$t('message.success.topSuccess')
      cancelAttSuccess:'Cancel attention succeeded',//this.$t('message.success.cancelAttSuccess')
      modifySuccess:'Modified successfully',//this.$t('message.success.modifySuccess')
      enjoySuccess:'Exclusive success',//this.$t('message.success.enjoySuccess')
      closeSuccess:'Closed successfully',//this.$t('message.success.closeSuccess')
      subscribeSuccess:'Subscription succeeded',//this.$t('message.success.subscribeSuccess')
      followSuccess:'Focus on success',//this.$t('message.success.followSuccess')
      mergeSuccess:'Successful merger',//this.$t('message.success.mergeSuccess')
      mergeSuccessfollow:'Successful merger(If the enterprise you are merging is your [concerned] merged enterprise, when you merge this enterprise, this enterprise will be removed from your list of concerned enterprises. Please pay attention again.)',
      addSuccessLook:'After adding successfully, you can view the list of added business opportunities in the overview page of the system, and edit or subscribe.',//this.$t('message.success.addSuccessLook')
      createdSuccess:'Created successfully',//this.$t('message.success.createdSuccess')
      saveSuccess:'After saving successfully, you can view the list of added business opportunities in the overview page of the system, and edit or subscribe.',//this.$t('message.success.saveSuccess')
      addSuccess:'Added successfully',//this.$t('message.success.addSuccess')
      saveSuccessOver:'Saved successfully.',//this.$t('message.success.saveSuccessOver')
      cancelLookSuccess:'Unsubscribe succeeded',//this.$t('message.success.cancelLookSuccess')
      custoremTableSuccess:'Custom table succeeded',//this.$t('message.success.custoremTableSuccess')
      passwordModifiedSuccess:'Password modified successfully',//this.$t('message.success.passwordModifiedSuccess')
      versionSwitchsucceed:'Version switching succeeded.',//this.$t('message.success.versionSwitchsucceed')
      wechatBindingSucceed:'Wechat binding succeeded',//this.$t('message.success.wechatBindingSucceed')
      HasBeenAddEasySearchEmailContact:'Has been added as an easy to search email contact'//this.$t('message.success.HasBeenAddEasySearchEmailContact')
    },
    rules:{
       enterKeyword:' Please fill in product keywords'//this.$t('message.rules.enterKeyword')
    }
  },
   // components start 
   components: {
    exportitems: {
      selected: 'Selected', // {{$t('components.exportitems.selected')}}
      exportQuantity: 'The Number Of Download Companies',
      tradeNum: 'Number Of Trade Data',
      whichContains: 'Include',
      onceDownloaded: 'already downloaded',
      onceTradeDownloaded: 'already downloaded',
      notOpen: 'Not Open Download.',
      chooseDown: 'In the download file, the historically download company will not be included',
      tradeDownNum: 'Number of trade data downloads',
      consumptionNeed: 'Download Requires',
      exportNum: 'number of downloads ',
      surplus: 'Remaining',
      currentChoose: 'Selected',
      downTips: 'Number Of Downloads',
      beenExceeded: ', Exceeded account balance',
      ifConfirmed: ', if confirmed',
      systemIs: ', system will',
      customNeed: 'vailable data',
      recharge: 'Recharge',
      exportEnterpriseList: 'Download business list',// {{$t('components.exportitems.exportEnterpriseList')}}
      downloadIntelligence: 'Download trade data',
      enterprise: 'Enterprise',
      tradeData: 'Trade Data',
      point: 'Point',
      articles: 'Number of articles',
    },
    header:{
      login: 'Login',
      updateAnnouncement: 'Notifications',
      accountCenter: 'Account',
      LogOut: 'Log out',
    },
    leftFilter: {
      pleaseEnter: 'Please enter',
      switchLegacy: 'name and press enter to create',
      startTime: 'Start date',
      endTime: 'End date',
      to: '-',
      putAway: 'Hide',
      expandOptions: 'Show all options',
      topFloor: 'Go to top',
      collapseFilter: 'Hide',
      expandFilter: 'Show',
      Currentdataperiod:'Data query period',
      lastmonth:'last month',
      lastthreemonths:'last three months',
      latestyear:'latest year',
      lastthreeyears:'last three years',
    },
    promptInformation:{
      thanks: 'Any questions, please contact customer service, tks',
      backHome: 'Back Home',// {{$t('components.promptInformation.backHome')}}
      previouPage:"Previous page",
    },
    translate: {
      systemTran: 'The system will automatically translate the keywords you entered into the following languages for search. You can also click the Edit button to correct the automatically translated content to ensure more accurate search results:',
      surceChange: 'Confirm', // {{$t('components.translate.surceChange')}}
    }
  },
  // components end 
  //homes  start
  homes: {
    enterSystem:"enter",
    enter: 'enter ',
    intoCapital: 'Maximizing the Value of Data & Information',
    search: ' Search...',
    productName: 'Product',
    hsCode: 'HS Code',
    companyName: 'Company',
    allCountry: 'All countries',
    whole: 'All',// {{$t('homes.whole')}}
    global: 'Global',// {{$t('homes.global')}}
    strength: 'comprehensive strength',
    found: 'Founded in 2004 and invested by donghaolansheng group, a large state-owned enterprise, it is the designated partner of the international e-commerce center (CIECC) of the Ministry of Commerce. It has cooperated with Deng Baishi and other global business intelligence and digital marketing enterprises for many years. It has helped more than 30000 Chinese foreign trade enterprises in digital marketing transformation and sustainable growth, and continued to promote the application of data in overseas marketing and global business competition.',
    dataResources: 'Data resources',
    accumulation: '17 years of data accumulation, more than 3000tb of data, including 70 billion data. According to the amount, the trade data of recent one year covers more than 70% of the global transaction intelligence data that can be queried; The introduced Dun & Bradstreet business data and multinational business directory contain more than 400 million global enterprise information, covering 1000 + industry background and in-depth analysis information, and more than 140 million business contact information, helping foreign trade enterprises break through business bottlenecks.',
    technical: 'Technical capability',
    useData: '-Use the cutting-edge big data technology framework to process the millisecond response of Pb level data< Br > - micro services, PAAS platform services, flexible expansion, SaaS upgrade products< Br > - machine learning algorithm and artificial intelligence, intelligent response to front-end requirements< Br > - 100 + servers, 50 + data technology operation and maintenance team, stable and worry free.',
    serviceExperience: 'Service experience',
    absorbed: 'Focusing on serving foreign trade enterprise customers, reliable data consultants provide full support; Focusing on customer needs, we are committed to providing professional and warm customer service; Through the operation of mature service system, deepen customer connection, help customers accelerate the expansion and landing of wells on the new track in the digital intelligence era, and become more competitive in dealing with the fierce and complex global trade market environment.',
    alldatasources:'All data',
    justlookatthenew:'Just look at the new',
    Trendchart:'Trend chart',
    Piechart:'Pie chart',
    Purchaser:'Purchaser',
    supplier:'supplier',
    businessdirectory:'business directory',
    businessData:'business data',
  },
  //homes  end
  // 头部
  header: {
    projectName: 'Global trade 5.0',
    change: 'Go to',
    enter: 'enter',
    navBar: {
      overView: 'Overview',
      teeSou: 'Companies',
      businessData:'Business data',
      tradeIntelligence: 'Trade data',
      productAnalysis: 'Product analysis',
      trendAnalysis: 'Trend analysis',
      analysisReport: 'Market research',
      userCenter: 'user center'
    },
  },
  //商机列表
  opportunityList: {
    opportunityListTitle: 'Business Intelligent List',
    FocusonEnterprises:'The number of enterprises that can be followed is the upper limit of enterprises that can be followed by each account or sub account.',
    Exportenterprise:'The number of enterprises that can be exported is the total remaining quantity of your company. All sub accounts share the current quantity. The sub account needs to be used when the master account opens the download permission.',
    Downloadtransaction:'The number of downloadable transactions is the total number remaining in your company, and all sub accounts share the current number. The sub account needs to be used when the master account opens the download permission.',
  },
  //账户概况
  accountOverview: {
    accountOverview: 'User Preferences',
    accountID: 'Account ID',
    affiliatedCompany: 'Company',
    expirationDate: 'Expiry Date',
    surplus: '',
    day: 'day',
    numberOfSubAccounts: 'Number of sub-accounts',
    countriesOpened: 'Open countries',
    customerService: 'Customer Service',
    Tel: 'Tel',
    Mobile: 'Mobile',
    Email: 'Email',
    Enterprise: 'WeChat',
  },
  dashboardCont: {
    childfollow: 'Sub-account Follow',
    followandcollect: 'Follow and Collect',
    businessopportunitylist: 'Business Opportunity List',
    smartList: 'Opportunity list',
    souLabel: 'Company Search Tag',
    followent: 'Follow Enterprises',
    bookmarkorders: ' Bill of Lading Collected',
    bookmarksorders: 'Bookmarked Orders',
    downloadcenter: 'Download Center',
    downloadfiles: 'Downloaded Files',
    downloadtrad: 'Download Tradedata',
    exportent: 'Export Enterprises',
    monthly: 'New this month',

    focusEnterprises: 'Follow company',
    manageEnterprises: 'manage sub accounts and follow company',
    lable: 'label',
    childAbout: 'switch to sub account attention',
    backAbout: 'back to my attention',
    address: 'country/region',
    byWeek:'weekly',
    byMonth:'monthly',
    byYear:'annually',
    chooseAddress: 'choose',
    chooseType: 'choose',
    subAccount: 'sub-Account',
    pleaseSelect: 'choose',
    exportRecords: 'download record',
    selectAllList: 'Select all',
    downloadEnterprise: 'download company',
    downloadRecord: 'download data Record',
    administration: 'manage',
    adviceTag: 'In order to make it easier for you to distinguish the concerned companies, it is recommended that you add one or more custom labels for the concerned companies, such as date, company type, product name, etc.',
    addLable: 'Add Lable',
    listOrder: 'Business Intelligent List subscrription rules',
    listOrderAbout: 'follow company List subscrription rules',
    openRead: 'When you open the subscription, the system will regularly provide you with email or wechat notifications according to the rules set below, so as to help you better understand the market.',
    notificationMethod: 'notification method',
    enterContent: 'please enter the content',
    subscriptionCycle: 'Notification frequency',
    everyDataChange: 'when data updata',
    modifySubscription: 'Subscription',
    cancelAttention: 'Unfollow',
    setPassword: 'Assigning Account Passwords',
    weclomeLogin: 'Welcome to Topease E platform. For account security, please set a login password and complete the activation process.',
    originalPassword: 'original password:',
    originalPasswordEnter: 'please enter the original password',
    loginPassword: 'login password:',
    loginPasswordRequirement: 'please enter a password consisting of 8 ~ 20 digits, letters or numbers',
    duplicatePassword: 'Re-enter password:',
    passwordSure: 'Please re-enter the password again to confirm the accuracy of the password',
    next: 'next',
    selfTarget: 'Account Personalization',
    selfTargetResult: 'The personalized goals you set will optimize the buyers or suppliers recommended by the system, allowing you to obtain better query results.',
    queryProducts: 'Main search products:',
    enterKeyword: 'Please enter at least one product keyword, not limited to Chinese or English',
    interestedCountry: 'Countries of interest:',
    countryAdd: 'Country/Region:',
    interestedCountryEnter: 'Please select the country / region of interest',
    sureNext: 'OK, next step',
    useWeChat: 'Bind WeChat',
    useWeChatOver: 'After scanning the QR code to confirm the binding, you can log in to the E platform using wechat.If you need to unbind, you can go to the account center and unbind yourself, or unbind through the company is main account. ',
    scanCode: 'refresh wechat QR code',
    skip: 'Skip',
    productkey: 'Product',
  },
  //系统消息
  systemInformation: {
    systemInformation: 'Notifications'
  },
  //表格组件
  tableComponent: {
    batchOperation: 'Multi select',
    intervalDownload: 'Batch Download',
    analysis: 'analysis',
    download: 'download',
    search: 'Enter keywords to search',
    total: 'total',
    strip: '',
    goTo:'Go to',
    page:'page'
  },
  //表格头部
  tableHeader: {
    listName: 'List name',
    updataTime: 'Updata time',
    type: 'Type',
    numberOfBuyers: 'Buyers',
    numberOfSuppliers: 'Suppliers',
    subscription: 'Subscription',
    viewList: 'View list',
    downloadListEnterprise: 'Download',
    delete: 'Delete',
    mode: 'Mode',
    searchContent: 'Search',
    searchAgain: 'Re search',
    enterprisesNum: 'Company',
    labelName: 'Label',
    market: 'Market',
    IncreaseAmount: 'Increase amount',
    growthRatio: 'Growth ratio',
    dataSource: 'Data source',
    sourceType: 'Data source type',
    tradeRole: 'Trade routes',
    tradePercentage: 'Number of Trade(Ratio)',
    amount: 'Amount (USD)',
    contacts: 'contacts',
    sourceMode: 'Data source',
    position: 'Position',
    fax: 'Fax',
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
    yearTotal: 'Year total',
    tradeNum: 'Number of Trade(Ratio)',
    newTradetime: 'Latest Trade Date',
    suppNum: 'Number of suppliers',
    amountNum: 'Amount (USD)',
    nearlyData: 'Latest trading time',
    buyNum: 'Number of purchasers',
    tradeLine: 'Trade route',
    tradTrend: 'Trade trend',
    codeDes: 'HS code description',
    allAcount: 'Total amount',
    proportion: 'Ratio',
    increaseAmount: 'Growth ratio',
    growthRatio: 'growth',
    timeSlot: 'period',
    tradePerson: 'partner',
    registeredAdd: 'Register address',
    numOne: 'First quantity',
    numOneUnit: 'First UOM',
    numOneUnitPrice: 'First measurement average price',
    numTwo: 'Second quantity',
    numTwoUnit: 'Second UOM',
    numTwoUnitPrice: 'Second measurement average price',
    absolutData: 'Absolute value of trade balance',
    differenceType: 'Difference type',
    departure: 'Port of departure',
    countryOrigin: 'Country of origin',//{{$t('tableHeader.countryOrigin')}} this.$t('tableHeader.countryOrigin')
    destinationCountry: 'Destination country',// this.$t('tableHeader.destinationCountry')
    enterpriseScreening: 'Enterprise Filter',//this.$t('tableHeader.enterpriseScreening')
    trade: 'Trade',
    boxNumT: 'TEU',
    enterpriseName: 'Company name',
    tradeMonth: 'Trading month',
    tradeNumS: 'Number of trade',
    mun: 'Quantity',
    weight: 'Weight',
    boxNum: 'Number of boxes',
    boxNums: 'TEUs',
    munE: 'Quantity',//this.$t('tableHeader.mun')
    weightE: 'Weight',//this.$t('tableHeader.weight')
    boxNumE: 'Number of boxes',//{{$t('tableHeader.boxNum')}} this.$t('tableHeader.boxNum')
    countryName: 'Country/Region',
    purchaserName: 'Buyer',
    supplierName: 'Supplier ',
    notifierName: 'Notifier ',
    brandName: 'Brand',
    tradeAllNum: 'Number of trade',
    totalNum: 'Total quantity',
    totalWeight: 'Total weight',
    destination: 'Port of destination',
    ranking: 'Ranking',
    HSdescription: 'HS description',
    times: 'Times',
    subAccount: 'Sub account',
    focusTime: 'Follow date',
    subscribe: 'subscribe',
    exclusive: 'Exclusive',
    tradeNumT: 'Number of trade',
    viewDetails: 'Details',
    yisou: 'Tesour',
    cancelView: 'Cancel follow',
    tradeProd: 'Trade products',
    generationTime: 'Date created',
    downloadEnterprise: 'Download',
    cancelAttention: 'Cancel follow',
    exportFile: 'Export file',
    modifyLabel: 'Edit label',
    enterprisesIncluded: 'Number of company',
    actualDeduction: 'Actual deduction',
    downloads: 'Amount of downloads',
    downloadNew: 'Download again',
    exportFile: 'Download file',
    tradeNum: 'Number of trade',
    singleRecord: 'Single record',
    monthlyStatistics: 'Monthly statistics',
    AnnualStatistics: 'Annual statistics',
    TradingYearOrMonth: 'Trade Month',
    TradingYear:'Trade Year',
    month: 'Month',
    amount:'Amount',
    rate:'Rate',
    enterpriseId: 'Enterprise ID',
    enterpriseCountry: 'Country',
    enterpriseMerge: 'Merger'
  },
  // dashboard end
  // company result satrt
  resultHeader: {
    productKeywords: 'Product',
    hsCode: 'HS Code',
    companyName: 'Company',
    searchCompany: 'search company',
    advancedSearch: 'Advanced search',
    queryData: 'Search data',//{{$t('resultHeader.queryData')}}
    historicalSearch: 'Historical Search',//{{$t('resultHeader.historicalSearch')}}
    viewSearchHistory: 'Search history'
  },
  resultTop: {
    recommendedKeywords: 'Suggested keywords',
    relevantHScode: 'Relevant HS code',//this.$t('resultTop.relevantHScode'),
    lenovoCompanyName: 'Lenovo company name',//this.$t('resultTop.lenovoCompanyName'),
    changeBatch: 'change batch',
    displayEnglish: 'display english',
    displayChinese: 'display chinese',
    pleaseChoose: 'please select',
    have: 'have ',
    or: 'About ',
    individual: ' individual ',
    of: 'of',
    addSmartList: 'add as opportunity list',
    smartSort: 'intelligent sorting'
  },
  resultContain: {
    tradeTime: 'trade time',
    tradeTotal: 'trade total',
    consolidatedEnterprise: 'consolidated enterprise',
    contMessage: 'Contact information already included',
    easyMail: 'Easy mail',
    easySearchMail: 'Easy search mail',
    easySearchMailNew:'Search',
    concerned: 'Concerned',
    follow: 'follow',
    Industry: 'Industry',
    latestTransactionDate: 'latest transaction date',
    totalTransactionOrders: 'total transaction orders',
    numberOfRelatedPurchaseOrders: ' number of related purchase orders',
    numberOfRelatedSuppliersOrders: 'number of related supplier orders',
    secondaryCorrelation: 'correlation',
    transactionHScode: 'transaction HS code',
    lookMore: 'see more',
    descriptionTradedGoods: 'description of traded goods',
    websiteImg: 'Official website pictures',
    supplier: 'supplier',
    buyer: 'Corresponding product purchaser',
    buyerhave: 'Purchaser ownership',
    tradeProportion: 'Proportion of transaction times',
    newTradeTime: 'Latest trading time',
    putAway: 'Put away',
    showAdditional: 'Show additional',
    correspondingPurchaser: 'corresponding purchaser',
    batchOperationEnterprise: 'batch operation enterprise',
    selected: 'selected',
    Enterprise: 'Enterprise',
    batchOperation: 'batch operation',
    selectallpage: 'select all page',
    deselectAll: 'deselect all',
    batchSelection: 'batch selection',
    batchAttention: 'batch attention',
    exportEnterprise: 'Download',
    consolidatedEnterprise: 'consolidated enterprise',
    chooseCorAdd: 'select country',
    findCountry: 'Type country name',
    mergeList: 'consolidated enterprise list',
    enterpriseScrip: 'The following enterprises have been merged and displayed. Enterprise operations will only affect your viewing and statistics results, and will not affect other accounts. You can select one of these enterprises as the master enterprise and display its name. To cancel the merge, click delete.',
    mainEnterprise: 'main enterprise',
    addTagSelf: 'add custom labels for enterprises of interest',
    advice: 'In order to make it easier for you to distinguish the concerned companies, it is recommended that you add one or more custom labels for the concerned companies, such as date, company type, product name, etc.',
    addTag: 'add label',
    enter: 'enter anything and press enter',
    recommendedLabel: 'recommended label',
    aCostomer: 'Class A customers',
    bCustorem: 'Class B customers',
    dontAbout: 'do not pay attention for the time being',
    confirmAdd: 'confirm add',
    Valueafter:'Value after country',
    Numberof:'Total number of transactions of each data type in the country / region under the current search criteria',
    numberoft:'Number of purchasers',
    ofsuppliers:'Number of suppliers',
  },
  companyResultsJS:{
    relatedCompany: 'Related to company name', // this.$t('companyResultsJS.relatedCompany')
    relatedDes: 'Related to description',
    relatedNum: 'Related to tax number',
    unlimitedBuy: 'Unlimited purchasing area',
    onlyChina: 'Only Chinese purchasing experience is shown',
    onlyChinaBuy: 'Purchase from China',
    enterpriseDirectory: 'Enterprise directory',
    tradeRole: 'Trade Role', // this.$t('companyResultsJS.tradeRole')
    tradeRecord: 'Shipments',// this.$t('companyResultsJS.tradeRecord')
    tradeProducts: 'Products',// this.$t('companyResultsJS.tradeProducts')
    supplyAnalysis: 'Buyer&Supplier',// this.$t('companyResultsJS.supplyAnalysis')
    tradePort: 'Port Analysis',// this.$t('companyResultsJS.tradePort')
    businessInformation: 'Business',// this.$t('companyResultsJS.businessInformation')
    contactInformation: 'Contacts',// this.$t('companyResultsJS.contactInformation')
  },
  //leftFilter 组件
  leftFilter: {
    countryAndAddress: 'Country/Region',
    allCountry: 'all country',
    filter: 'filter',
    chooseTradeTime: 'choose trade time',
    chooseTradeAddress: 'choose trade address',
    excludeLogisticsCompanies: 'excludeLogistics companies',
    excludeBanks: 'exclude banks',
    contactInformationIncluded: 'contact information included',
  },
  // company result end
  // search start
  search: {
    search:'search',
    enterpriseList: 'List of enterprise distribution regions',
    tradeAddressList: 'List of transaction distribution regions',
    flag: 'national flag',
    multipleCompany: 'multi choice countries',
    multipleCompanyTag: 'one or more custom countries',
    smartList: 'Opportunity list',
    productDataTag: 'Product data label',
    queryCountry: 'Query country',
    selectCountry: 'Please select a country',
    fuzzyQuery: 'Fuzzy query',
    preciseQuery: 'Precise query',
    hsQuery: 'HS code query',
    filterRule: 'Filter rule',
    exclusionCategory: 'Exclusion category',
    billLading: 'Bill of lading',
    enterBill : 'Please enter the bill of lading (shipment) No',
    queryTool: 'National tax number query tool',
    translateChinese: 'Chinese',
    filterQuery: 'screen',
    andSearch: 'and Search',
    saveOther: 'save as',//{{$t('search.saveOther')}}
    clearAll: 'Clear all conditions',//{{$t('search.clearAll')}}
    searchResults: 'Results',//{{$t('search.searchResults')}}
    amountRange: 'Transaction amount range',//{{$t('search.amountRange')}}
    unitRange: 'Unit price range',//{{$t('search.unitRange')}}
    quantityRange: 'Quantity range',//{{$t('search.quantityRange')}}
    weightRange: 'Weight range',//{{$t('search.quantityRange')}}
    weightUnit: 'weight',//{{$t('search.weightUnit')}}
    caseNumber: 'Case number',//{{$t('search.caseNumber')}}
    enterCaseNumber: 'Please enter the case number',//{{$t('search.enterCaseNumber')}}
    enterKeys: 'Please enter HS code',//:placeholder="$t('search.enterKeys')Please enter keyword or HS code"
    cusent:"Shipping",
    cusentPlace:"Shipping",
    enterDescription: 'Please enter product description',//:placeholder="$t('search.enterDescription')"
    countryOriginD : 'Country of origin (country of export)',//{{$t('search.countryOriginD')}}
    DestinationCountry : 'Destination country (importing country)',//{{$t('search.DestinationCountry')}}
    clearCriteria : 'Clear all filter criteria',//{{$t('search.clearCriteria')}}
    editOpportunityList: 'Edit opportunity list',//this.$t('search.editOpportunityList')
    editProductTag: 'Edit product data labels',//this.$t('search.editProductTag')
    smartBusinessOpportunities: 'List of new business opportunities',//this.$t('search.smartBusinessOpportunities')
    newproductdatalabel:'New product data label',
  },
  //search end
  // company detail start
  companyDetail: {
    intervalDownData:'Please fill in the start and end serial numbers of the data to be downloaded', 
    share:'share',
    shareLink:'share link',
    shareCopy:'copy',
    downNumIndex:'Download range',
    dataChangeTime: 'Data update time',
    search: 'Search company',
    companyDetail: 'Company details',
    dataError: 'Data error correction',
    productDataTag: 'Consolidated enterprise',
    wait: 'etc.',
    individual: 'individual',
    selectImportType: 'Please select import and export type',
    sourceData: 'Please select a data source',
    morefilter: 'More filtering',
    monthStart: 'Start month',
    monthEnd: 'End month',
    supplyArea: 'Panorama of mining and supply area',
    tradeRecord: 'Trade record',
    translate: 'translate',
    tradeProducts: 'Trade products',
    perspectiveImg: 'Trade chain',
    supplierAnalysis: 'Supplier',
    proportionSuppliers: 'By Company',
    supplierDistribution: 'By Region',
    purchaserAnalysis: 'Buyer',
    proportionPurchasers: 'By Company',
    purchaserDistribution: 'By Region',
    buyPortAnalysis: 'Buyer Port Analysis',
    departure: 'Port of departure / customs area',
    portD: 'Port of destination / customs area',
    supplyPortAnalysis: 'Supply Port Analysis',
    businessInformation: 'Business information',
    IndustryCode: 'Industry code type',
    Industry: 'Industry',
    contactInformation: 'contact information',
    excavationTime: 'Last excavation time',
    contactYiSou: 'Add to Tesour',
    cardShow: 'Card',
    tableShow: 'Table',
    teYiContact: 'Teyi mining contacts throughout the network',
    moreContact: 'For more key people and contact information of the company, you can use [easy search mail] to mine the whole network',
    openYisou: 'Start easy mail',
    contactService: 'Teyi ASEAN field contact service',
    offlineGet: 'ASEAN offline entity verification service contact information acquisition, purchaser field visit',
    applicationService: 'Application service',
    addTageSelf: 'In order to make it easier for you to distinguish the concerned companies, it is recommended that you add one or more custom labels for the concerned companies, such as date, company type, product name, etc.',
    addTag: 'Add label',
    showCont: 'The following enterprises have been merged and displayed. Enterprise operations will only affect your viewing and statistics results, and will not affect other accounts. You can select one of these enterprises as the master enterprise and display its name. To cancel the merge, click delete.',
    mainEnterprise: 'Main enterprise',
    tradeData: 'transaction data',
    tradeDataDown: 'Download transaction data',
    datachangeError: 'Data error correction report',
    replyEmail: 'Email:',
    enterEmail: 'Please enter email address',
    enterEmailRight: 'Please enter the correct email address',//this.$t('companyDetail.enterEmailRight')
    contactPhone: 'Tel:',
    enterPhone: 'Please enter phone number',
    questionDse: 'Problem:',
    pageDes: 'Please briefly describe the questions about content / data in the current page.',
    countryAddList: 'List of countries and addresses',
    queryAdd: 'Address query',
    detailadd: 'Detailed address',
    intervalDownload: 'Interval Download',
    orderStart: 'Start sequence number',
    orderEnd: 'End sequence number',
    companyDetailFilter: 'Company details page filter',
    enterprise:'enterprise',
    Purchaser:'Purchaser',
    supplier:'supplier',
    Tradinggoods:'Trading goods',
    Purchasetimes:'Purchase times',
    Purchasegoods:'Purchase goods',
    Supplytimes:'Supply times',
    Supplytimes:'Supply goods',
    second:'second',
    detailStatistics:'Detail statistics'
  },
  //company detail end
  // product  start
  productDetail: {
    //detail
    eotifier: 'Notifier',
    manufacturer: 'manufacturer',//{{$t('productDetail.manufacturer')}}
    excludeNull: 'Exclude purchaser is null',
    supplNull: 'Exclude supplier is null',
    chooseDeparture: 'Please select the port of departure',
    chooseDestination: 'Please select the port of destination',
    countryOrigin: 'Please select country of origin',
    countryDestination: 'Please select destination country',
    marketTrendAnalysis: 'Market trend analysis',
    exportProportion: 'Proportion of import and export',
    departureAnalysis: 'Port of departure analysis',
    switchModify: 'Modify / switch HS',
    switchProduct: 'Modify / switch product HS code',
    //Product
    productAnalysis: 'Product analysis report',
    createAnalysis: 'Create a product analysis',
    tradeIntelligence: 'Trade intelligence data product analysis',
    createdProductA: 'Create product analysis',
    importExportType: 'Import and export type',
    countryChoice: 'Country choice',
    chooseCountry: 'Please select a country',
    productKey:'Product keywords',//{{$t('productDetail.productKey')}}
    enterHScode: 'Enter product HS code',
    openCode: 'The HS code range of the opened industry is as follows',
    pleaseEnterkeyWord: 'Please enter keywords',
    countryScreening: 'Data country screening',
    Targetcountry:'Country/Region',
    Productname:'Product/industry',
    Purchaserand:'Buyers/Suppliers',
    Logisticsrelated:'Logistics related',
    Commodityvolume:'volume and price',
  },
  //product end
  //trade  start
  tradeData:{
    tradeDetail:{
      tradeIntelligence: 'Trade Intelligence',
      IntelligenceDetail: 'Trade Intelligence details',
      dataChange: 'Data error correction',
      print: 'Print',
      fieldDescription: 'Field description',
      correctionReport: 'Data error correction report',
      changeOld:'Switch legacy',
      intelligenceList: 'Trade records', 
      marketTrendAnalysis: 'Market trend',
      share: 'share'
    },
    tradeResult:{
      productDescription:'Product',
      portAnalysis:'Destination port',
      averagePriceA:'Average price',
      brandAnalysis:'Brand',
      CountryAanalysis:'Country/Region',
      findHave:', find have',
      displayColumn:'Display column',//{{$t('tradeData.tradeResult.displayColumn')}}
      customTable:'Custom table',//{{$t('tradeData.tradeResult.customTable')}}
      addTradeTag:'Add as trade data tag',//{{$t('tradeData.tradeResult.addTradeTag')}}
      Transactions:'Transactions',//{{$t('tradeData.tradeResult.Transactions')}}
      advancedSearchCriteria:'Advanced search criteria',//{{$t('tradeData.tradeResult.advancedSearchCriteria')}}
      searchCriteria:'search criteria',//{{$t('tradeData.tradeResult.searchCriteria')}}
      throughYour:'Through your',//{{$t('tradeData.tradeResult.throughYour')}}
      enterLableName:'Please enter label name',//{{$t('tradeData.tradeResult.enterLableName')}}
      importdata:'（Current import data, the analysis content is export country or country of origin）',
      exportdata:'（Current export data, the analysis content is the importing country or destination country）',
      Fullscreen:"Fullscreen",
      FullscreenExit:"Exit full screen",
    }
  },
  //trade  end
  //trend
  trendAnalysis: {
    TrendAnalysis: 'trend analysis report',
    markete:'market',
    CreateMarketTrends: 'create market trends',
    SelectType: 'select type',
    ExclusiveToChina: 'exclusive to China',
    MarketDimension: 'market dimension',
    IndustryDimension: 'industry dimension',
    SelectproductHScode: 'select product HS code',
    ImportAnd: 'Import and export selection',
    Export: 'export',
    Import: 'import',
    ImportAndExport: 'import and export',
    SelectCountry: 'select country',
    PleaseSelectACountry: 'Please Select a country',
    PleaseSelectType: 'please select type',
    PleaseSelectHS: 'please select HS code product',
    CreatedSuccessfully: 'created successfully',
    ThisAccountHas: 'this account has no permission to create',
    YourTrendAnalysis: 'your trend analysis report has reached the creation limit',
    ThisOperation: 'this operation will delete the analysis report. do you want to continue?',
    DeleteSucceeded: 'Delete succeeded',
    ThisAccount: 'This account has no permission to delete',
    Importexport: 'Imp&Exp',
    dataTime: "Date",
    china: {
      DataPhase: 'data phase',
      ReportView: 'report view',
      dataTime:'date',// this.$t('trendAnalysis.china.dataTime')
      formView: 'table view',
      DataType: 'data type',
      TrendAnalysis: 'trend analysis',
      EntranceArea: 'entrance area',
      DuringtheabovePeriod: 'during the above period',
      FirstlargestinletArea: 'first largest inlet area',
      Oftotalimports: 'Of total imports',
      Thelargest: 'the largest importing country / region',
      Oftotalimportsp: 'of total imports',
      Thesecond: 'the second to fifth places are',
      Regional: 'regional distribution of imports',
      Downloadpictures: 'download pictures',
      Exportarea: 'export area',
      Thelargests: 'the largest export area',
      Oftotalexports: 'of total exports',
      Thelargestexport: 'the largest export country / Region',
      Oftotalexportsp: 'of total exports',
      Thesecondto: 'the second to fifth places are',
      Exportregional: 'export regional distribution',
      Importmarket: 'Import market dynamics',
      Growth: 'Growth value type',
      Duringthe: 'During the above period',
      Thefirstcountry: 'The first country / region with positive import growth',
      Thefirscountrynegative: 'The first country / region with negative import growth',
      negativegrowth: 'negative growth',
      increase: 'increase',
      Thesecondtofifth: 'the second to fifth places are',
      Byincreasedamount: 'By Amount',
      Bypercentagegrowth: 'By Percentage',
      Byproportion: 'by percentage',
      Bytotalamount: 'by total amount',
      linear: 'linear',
      exportmarketdynamics: 'export market dynamics',
      typesofValueAdded: 'types of Value Added',
      Duringtheabove: 'during the above period',
      Countrieswith: 'countries with Positive Export Growth First',
      Firstcountry: 'first country/region with negative export growth',
      Thesecondtofifthplaces: 'the second to fifth places are',
      Trademarket: 'trade market share trends',
      Graphictype: 'graphic type',
      Yaxis: 'Y-axis value',
      Theright: 'the right figure is',
      theabove: 'during the above period',
      Globaltrademarket: 'The trend of global trade market share during the above time period.',
      ModeofTrade: 'mode of trade',
      Thelargestmode: 'the largest mode of trade is',
      to: 'to',
      switchModify:'Modify / switch HS',
      switchproduct:'Modify / switch product HS code',
      Pleaseenter:'Please enter HS code',
      Trenddetails:'Trend details - trend analysis - foreign trade information treasure gt6 0',
      Unsubscribe:'Unsubscribe succeeded',
      Subscription:'Subscription succeeded',
      Modified:'Modified successfully',
      splyGrowth:'vs. SPLY growth',
      increase:'increase',
      total:'total',
      TradeCities:'Trade Cities'
    },
    industry: {
      EntranceArea: 'entrance area',
      DataPhase: 'data phase',
      DuringtheabovePeriod: 'during the above period',
      TrendAnalysis: 'trend analysis',
      FirstlargestinletArea: 'first largest inlet area',
      Thelargest: 'the largest importing country / region',
      Oftotalimports: 'Of total imports',
      Oftotalimportsp: 'of total imports',
      Thesecond: 'the second to fifth places are',
      Exportarea: 'export area',
      Thelargests: 'the largest export area',
      Thelargestexport: 'the largest export country / Region',
      Oftotalexports: 'of total exports',
      Oftotalexportsp: 'of total exports',
      Importmarket: 'Import market dynamics',
      typesofValueAdded: 'types of Value Added',
      Byincreasedamount: 'By Amount',
      Bypercentagegrowth: 'By Percentage',
      Byproportion: 'by percentage',
      Bytotalamount: 'by total amount',
      linear: 'linear',
      Thefirstcountry: 'The first country / region with positive import growth',
      Thefirscountrynegative: 'The first country / region with negative import growth',
      negativegrowth: 'negative growth',
      increase: 'increase',
      Trademarket:'trade market share trends',
      exportmarketdynamics:'export market dynamics',
      Countrieswith:'No. 1 country / region with positive export growth',
      Firstcountry:'The first country / region with negative export growth',
      Graphictype:'Graphic type',
      Yaxis:'Y-axis value',
      Theright :' The picture on the right shows the machine and',
      Globaltrademarket:'Trends in Global trade market share over the above period. Through the analysis of import statistics of various countries',
      tradebalance:'trade balance',
      Countries:'Countries / regions with the largest surplus',
      difference:'difference',
      Countriesregions:'Countries / regions with the largest deficit',
      Tradebalance:'Trade balance distribution map',
      NorthAmerica:'North America',
      SouthAmerica:'South America',
      Asia:'Asia',
      Europe:'Europe',
      Africa:'Africa',
      Oceania:'Oceania'
    },
    market:{
      trendanalysis:'trend analysis',
      markettrends:'market trends',
      international:'International Trade Statistics market trends',
      Internationaltrade:'International trade market trends',
      Tradetype:'Trade type',
      dataphase:'data phase',
      Industrytype:'Industry type',
      Displaydata:'Display data',
      theright:'The picture on the right shows',
      Thetrendof:'The trend of import and export trade in the above time period and the comparison of year-on-year trend in the corresponding time period.',
      markettrendst:'Trade market trends',
      change: 'switch',
      Importand:'Import and export products',
      Classification:'Classification method',
      Largest:'Largest',
      product:'product',
      oftotalimports:'Of total imports',
      thelargest:'The largest import source country / Region',
      thesecond:'The second to fifth places are',
      Product:'Product distribution',
      Sourcecountry:'Source country / region distribution',
      Regionaltrend:'Regional trend of import and export',
      Importsource:'mport source country / Region',
      Thesecondto:'The second to fifth growth countries / regions are',
      increase:'increase',
      DistributionMap:'Distribution map of import source countries',
      Downloadpictures:'Download pictures',
      Import:'import',
      Export:'export',
      Byamount:'by amount',
      Bygrowth:'by growth',
      Byshare:'by share',
      HS2bit:'HS 2-digit',
      HS4bit:'HS 4-digit',
      HS6bit:'HS 6-digit',
      HS8bit:'HS 8-digit',
      HS10bit:'HS 10-digit',
      whole:'whole',
      Nationaltax:'National tax number query tool',
      Pleaseenter:'Please enter keywords',
      Unsubscribe:'Unsubscribe succeeded',
      Subscription:'Subscription succeeded',
      to:'to',
      ImpProductdistribution:'Imp Product Distribution',
      ImpCountryoforigin:'Imp Country Of Origin'
    },
  },
  analysisReport: {
    open:'opened'
  },
  // trend result end
  // 调整时间段提示
  dataSource: {
    AdjustmentPeriod: 'Adjust time to view',
    from: 'From',
    to: 'to',
    details1: ',',
    details: 'results were found.'
  }
}
